import parachutingNormalYeti from '../../../../../../assets/images/characters/parachuting-normal-yeti.png'
import parachutingSilverYeti from '../../../../../../assets/images/characters/parachuting-silver-yeti.png'
import parachutingGoldYeti from '../../../../../../assets/images/characters/parachuting-gold-yeti.png'

import surferNormalYeti from '../../../../../../assets/images/characters/surfer-normal-yeti.png'
import surferSilverYeti from '../../../../../../assets/images/characters/surfer-silver-yeti.png'
import surferGoldYeti from '../../../../../../assets/images/characters/surfer-gold-yeti.png'

import adventurerNormalYeti from '../../../../../../assets/images/characters/adventurer-normal-yeti.png'
import adventurerSilverYeti from '../../../../../../assets/images/characters/adventurer-silver-yeti.png'
import adventurerGoldYeti from '../../../../../../assets/images/characters/adventurer-gold-yeti.png'

import swimmingNormalYeti from '../../../../../../assets/images/characters/swimming-normal-yeti.png'
import swimmingSilverYeti from '../../../../../../assets/images/characters/swimming-silver-yeti.png'
import swimmingGoldYeti from '../../../../../../assets/images/characters/swimming-gold-yeti.png'

import picnickerNormalYeti from '../../../../../../assets/images/characters/picnicker-normal-yeti.png'
import picnickerSilverYeti from '../../../../../../assets/images/characters/picnicker-silver-yeti.png'
import picnickerGoldYeti from '../../../../../../assets/images/characters/picnicker-gold-yeti.png'

import minerNormalYeti from '../../../../../../assets/images/characters/miner-normal-yeti.png'
import minerSilverYeti from '../../../../../../assets/images/characters/miner-silver-yeti.png'
import minerGoldYeti from '../../../../../../assets/images/characters/miner-gold-yeti.png'



export enum YetiType {
  Parachuting = 'Parachuting Yeti',
  Surfer = 'Surfer Yeti',
  Adventurer = 'Adventurer Yeti',
  Swimming = 'Swimming Yeti',
  Picnicker = 'Picnicker Yeti',
  Miner = 'Miner Yeti'
}

export interface YetiItem {
  name: YetiType;
  image: string;
  type: string;
  rarity: string;
  total: number;
  remaining?: number;
}

export const parachutingYetiList: YetiItem[] = [
  {
    image: parachutingNormalYeti,
    total: 7,
    type: 'Normal',
    name: YetiType.Parachuting,
    rarity: 'Unique'
  },
  {
    image: parachutingSilverYeti,
    total: 4,
    type: 'Silver',
    name: YetiType.Parachuting,
    rarity: 'Unique'
  },
  {
    image: parachutingGoldYeti,
    total: 2,
    type: 'Gold',
    name: YetiType.Parachuting,
    rarity: 'Unique'
  }
]

export const surferYetiList: YetiItem[] = [
  {
    image: surferNormalYeti,
    total: 17,
    type: 'Normal',
    name: YetiType.Surfer,
    rarity: 'Rare'
  },
  {
    image: surferSilverYeti,
    total: 8,
    type: 'Silver',
    name: YetiType.Surfer,
    rarity: 'Rare'
  },
  {
    image: surferGoldYeti,
    total: 4,
    type: 'Gold',
    name: YetiType.Surfer,
    rarity: 'Rare'
  }
]

export const adventurerYetiList: YetiItem[] = [
  {
    image: adventurerNormalYeti,
    total: 33,
    type: 'Normal',
    name: YetiType.Adventurer,
    rarity: 'Uncommon'
  },
  {
    image: adventurerSilverYeti,
    total: 16,
    type: 'Silver',
    name: YetiType.Adventurer,
    rarity: 'Uncommon'
  },
  {
    image: adventurerGoldYeti,
    total: 8,
    type: 'Gold',
    name: YetiType.Adventurer,
    rarity: 'Uncommon'
  }
]

export const swimmerYetiList: YetiItem[] = [
  {
    image: swimmingNormalYeti,
    total: 33,
    type: 'Normal',
    name: YetiType.Swimming,
    rarity: 'Uncommon'
  },
  {
    image: swimmingSilverYeti,
    total: 16,
    type: 'Silver',
    name: YetiType.Swimming,
    rarity: 'Uncommon'
  },
  {
    image: swimmingGoldYeti,
    total: 8,
    type: 'Gold',
    name: YetiType.Swimming,
    rarity: 'Uncommon'
  }
]

export const picnickerYetiList: YetiItem[] = [
  {
    image: picnickerNormalYeti,
    total: 42,
    type: 'Normal',
    name: YetiType.Picnicker,
    rarity: 'Common'
  },
  {
    image: picnickerSilverYeti,
    total: 20,
    type: 'Silver',
    name: YetiType.Picnicker,
    rarity: 'Common'
  },
  {
    image: picnickerGoldYeti,
    total: 10,
    type: 'Gold',
    name: YetiType.Picnicker,
    rarity: 'Common'
  }
]

export const minerYetiList: YetiItem[] = [
  {
    image: minerNormalYeti,
    total: 42,
    type: 'Normal',
    name: YetiType.Miner,
    rarity: 'Common'
  },
  {
    image: minerSilverYeti,
    total: 20,
    type: 'Silver',
    name: YetiType.Miner,
    rarity: 'Common'
  },
  {
    image: minerGoldYeti,
    total: 10,
    type: 'Gold',
    name: YetiType.Miner,
    rarity: 'Common'
  }
]